/**
 * End point shown in the route form. A saved route keeps its end point so a
 * plain edit (e.g. a time change) does not silently drop the return leg; a
 * new route starts without one and the user adds it with the "home" button.
 */
export const initialEndPoint = (route) => (route?.id ? route.endPoint ?? '' : '');

/**
 * Return-leg distance that counts towards route totals. A route without an
 * end point has no return leg, so a leftover distance is ignored
 * (mirrors Route::countedEndPointDistance()).
 */
export const countedEndPointDistance = (endPoint, endPointDistance) =>
  (endPoint?.trim() ? (Number(endPointDistance) || 0) : 0);
